module.exports = __webpack_public_path__ + "img/image17.a25a3293.jpg";